import axios from 'axios';
import type { GetHistoryDTO } from '@bb/domain/dist/types';

const getHistory = async () => {
  const { data } = await axios.get<GetHistoryDTO>(`/search/recents`);
  return data;
};

export default getHistory;
